<template>
<div class="envision-container">

    <div class="box mt-5">
    
    
        <div class="has-text-centered is-block">
            <img src="/images/envision.png" alt="Envision Logo"  width="180" heigh="180" />
        </div>

        <!-- Select event screen -->
        <div class="select-event-container" v-if="stage == 'start'">
            <h1 class="is-size-4 has-text-centered">Book Travel For Your Envision Event</h1>
            <h2 class="is-size-5 has-text-centered has-text-grey mb-5">With TripCircuit from Gant Travel</h2>

            <b-notification type="is-info is-light">
                Please enter the contact details for the person attending the event below. We will send a verification code to the email and mobile phone you enter.
            </b-notification>

            <form>

                <b-notification v-if="validationError" type="is-danger is-light">
                    {{ validationError }}
                </b-notification>

                <b-field v-if="showEventSelector" label="Select the event" :label-position="labelPosition" :class="fieldClass">
                    <b-select v-model="eventId" expanded required>
                        <option
                            v-for="option in events"
                            :value="option.id"
                            :key="option.id">
                            {{ option.displayName }}
                        </option>
                    </b-select>
                </b-field>

                <b-field v-if="!showEventSelector && event" label="Event" :label-position="labelPosition" :class="fieldClass">
                    <b-input :value="event.displayName" disabled> 
                    </b-input>
                </b-field>

                <b-field label="Event attendee's email" :label-position="labelPosition" :class="fieldClass">
                    <b-input type="email" v-model="email" required> 
                    </b-input>
                </b-field>

                <b-field label="Event attendee's mobile phone (optional)" :label-position="labelPosition" :class="fieldClass" :message="mobilePhoneValidationStateMessage" :type="mobilePhoneValidationStateClass">
                    <vue-tel-input v-model="mobilePhone" defaultCountry="US" mode="international" @validate="mobilePhoneValidate"></vue-tel-input>
                </b-field>

                <b-button @click="beginVerifyDetails" type="is-primary" class="mt-4">Save and Send Verification Code</b-button>
            </form>
        </div>
        <!-- End Select event screen -->

        <!-- Verify screen -->
        <div class="verify-email-container" v-if="stage == 'verify'">

            <h1 class="is-size-4 has-text-centered">Enter Your Verification Code</h1>

            <h2 class="is-size-5 has-text-centered has-text-grey mb-3" v-if="event">{{ event.name }}</h2>

            <b-notification v-if="email != null || mobilePhone != null" class="is-info is-light mt-3">
                <h4 class="is-size-5">Your verification code has been sent!</h4>
                <p>Please enter it below to continue.</p>
                
                <div class="content">
                    <ul>
                        <li v-if="email">Email sent to <strong>{{ email }}</strong></li>
                        <li v-if="mobilePhone">SMS text message sent to <strong>{{ mobilePhone }}</strong></li>
                    </ul>
                </div>
                
                <p><strong>Didn't receive your code?</strong> It may take a minute or two to arrive.</p>
                <p>If you have a typo and want to try again <a @click="changeStage('start')">go back to previous step</a>.</p>
            </b-notification>

            <b-notification v-if="verificationError" type="is-danger is-light">
                    {{ verificationError }}
            </b-notification>

            <b-field label="Verification code" :label-position="labelPosition" :class="fieldClass" class="mt-6">
                <b-input type="" v-model="enteredVerificationCode">
                </b-input>
            </b-field>

            <b-button @click="checkVerificationCode" type="is-primary" class="mt-4">Confirm Verification Code</b-button>
        </div>
        <!-- End Verify screen -->

        <!-- Loading screen -->
        <div class="loading-container" v-if="stage == 'loading'">
            loading
        </div>
        <!-- End Loading screen -->
        
        <!-- Success screen -->
        <div class="success-container" v-if="stage == 'success'">
            <b-notification type="is-success is-light">
                Thank you for verifying your contact details. You will now be logged in to begin booking your trip.
            </b-notification>
        </div>
        <!-- End Success screen -->
    </div>

    <div class="has-text-centered">
        <strong>TripCircuit</strong> by <a href="https://www.ganttravel.com/" target="_blank">Gant Travel</a>
    </div>
</div>
</template>

<script>

import { VueTelInput } from 'vue-tel-input';
var moment = require('moment');

export default {
    name: 'WorldstridesEnvisionAuth',
    components: {
        VueTelInput,
    },
    props: {},
    data: function () {
        return {
            labelPosition: 'on-border', // inside, on-border, null
            fieldSize: null,
            fieldClass: 'mb-5',
            stage: 'start', // select-event
            events: [], // the list of meetings
            eventId: null, // the selected meeting
            showEventSelector: true,
            mobilePhone: null,
            email: null,
            verificationKey: null,
            enteredVerificationCode: null,
            validationError: null,
            verificationError: null,
            validMobilePhone: null,
        }
    },
    methods: {
        loadEvents() {
            let events = []

            this.$app.huddleLabsServerCall('meetings/worldstrides-envision/meetings').then(result => {
                if (result.data) {
                    for (let meeting of result.data) {
                        let displayName = meeting.name + ', ' + meeting.meetingLocation

                        if (meeting.meetingStartDate) {
                            let startDate = moment(meeting.meetingStartDate).format('MMM D, YY')
                            displayName+= ' (' + startDate
                        }

                        if (meeting.meetingEndDate) {
                            let endDate = moment(meeting.meetingEndDate).format('MMM D, YY')
                            displayName+= ' - ' + endDate + ')'
                        }

                        let event = {
                            id: meeting.id,
                            name: meeting.name,
                            displayName: displayName,
                            status: meeting.status
                        }

                        if (this.$route.query.code) {
                            if (this.$route.query.code == meeting.registrationCode) {
                                this.eventId = meeting.id
                                this.showEventSelector = false
                            }
                        }

                        events.push(event)
                    }
                }
            })

            return events
        },
        changeStage(stage) {
            this.stage = stage
        },
        beginVerifyDetails() {
            
            if (!this.performValidation()) {
                return
            }

            // Send email or mobile phone verification code
            if (this.email || this.mobilePhone) {
                this.sendVerificationCode()
            }

            // Set next stage based on type of verification used
            this.stage = 'verify'
        },
        performValidation() {
            let isValid = false
            this.validationError = 'Please select an event and enter an email address.'

            if (this.eventId && this.email) {
                isValid = true
                this.validationError = null
            }

            return isValid
        },
        sendVerificationCode() {
            if (!this.email && !this.mobilePhone) return

            var body = {
                email: this.email,
                mobilePhone: this.mobilePhoneFormatted,
            }

            this.$app.huddleLabsServerCall('actions/send-verification-code', body).then(result => {
                this.verificationKey = result.key
            })
        },
        checkVerificationCode() {

            var body = {
                key: this.verificationKey,
                enteredCode: this.enteredVerificationCode,
            }

            this.$app.huddleLabsServerCall('actions/verify-code', body).then(result => {
                // Success
                if (result.status == 'confirmed') {
                    this.handleSuccessfulVerification()
                }

                // Fail
                this.handledFailedVerification()
            })

            
        },
        handleSuccessfulVerification() {
            // Codes do match
            this.stage = 'success'
            this.verificationError = null
            this.findOrCreateUser()
        },
        handledFailedVerification() {
            this.verificationError = 'The verification code you entered "' + this.enteredVerificationCode + '" does not match the verification code that was sent.'
        },
        findOrCreateUser() {
            let meetingAttendee = null

            // Use the email or mobile phone to find a Salesforce contact record
            // Pass in the meeting ID so we can see if the contact is associated with this meeting
            // and we can create the contact and meeting attendee via the single API call

            var body = {
                meetingId: this.eventId,
                email: this.email,
                mobilePhone: this.mobilePhoneFormatted,
            }

            this.$app.huddleLabsServerCall('meetings/worldstrides-envision/retrieve-or-create', body).then(result => {
                
                // console.log(result.data)

                // Success
                if (result.data.attendeeId) {
                    this.redirectToLogin(result.data)
                }
            })

            return meetingAttendee
        },  
        redirectToLogin(attendeeData) {
            // console.log(attendeeData)

            let params = {
                email: attendeeData.email,
                access_code: attendeeData.attendeeAccessCode,
                meeting_code: attendeeData.meetingCode,
            }

            let paramsString = new URLSearchParams(params).toString();
            let urlPath = '/meetings?' + paramsString

            // console.log('Redirect to: ' + urlPath)

            this.$router.push({ path: urlPath })
        },
        mobilePhoneValidate(phoneObject) {
            this.validMobilePhone = phoneObject.valid
        },
    },
    mounted(){
        this.events = this.loadEvents()
    },
    computed: {
        mobilePhoneFormatted() {
            if (!this.mobilePhone) return null
            var phone = this.mobilePhone
            return phone.replace(/\s+/g, '')
        },
        mobilePhoneValidationStateClass() {
            let type = null
            
            if (this.validMobilePhone == true) {
                type = 'is-success'
            } else if (this.validMobilePhone == false) {
                type = 'is-danger'
            }

            return type
        },
        mobilePhoneValidationStateMessage() {
            let type = null
            
            if (this.validMobilePhone == true) {
                type = 'Valid phone number. Thank you!'
            } else if (this.validMobilePhone == false) {
                type = 'Please enter a valid phone number.'
            }

            return type
        },
        event() {
            if (!this.eventId) return null

            let events = this.events

            events = events.filter(event => {
                return event.id == this.eventId
            })

            if (events.length != 1) {
                return null
            } 

            let event = events[0]

            return event
        }
    }
}


</script>

<style src="vue-tel-input/dist/vue-tel-input.css"></style>

<style>
.envision-body {
  background: #E1E3E8;
}

/* .site__padding {
    padding-top: 0px;
} */

/* footer.footer {
    background: none !important;
} */

.envision-container {
    width:500px;
    max-width: 96%;
    margin: 0 auto;
}

input:invalid:required, select:invalid:required {
    background: inherit;
}

</style>
